import React, {useEffect, useState} from 'react';
import cls from "classnames";
import Input from "../Input";
import ButtonComponent from "../Button";
import './styles.less';

const searchOptions = [
    "theoodie.com",
    "murs-du-temps.com",
    "aglaiaco.com",
    "retrospec.com",
];

const Index = ({error, setError, loading, submit, isMobile, initialUrl}) => {

    const [inputValue, setInputValue] = useState(initialUrl || '');
    const [disabled, setDisabled] = useState(!isValidInput(initialUrl || ''));

    useEffect(() => {
        if (initialUrl) {
            setInputValue(initialUrl);
            setDisabled(!isValidInput(initialUrl));
        }
    }, [initialUrl]);

    function handleChange(e) {
        const value = e.target.value;
        setInputValue(value);
        setError('');
        setDisabled(!isValidInput(value));
    }

    function handleSelectOption(option) {
        setInputValue('https://' + option);
        setError('');
        setDisabled(!isValidInput(option));
    }

    function isValidInput(value) {
        if (!value || typeof value !== 'string') {
            return false;
        }

        const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w\-.~:/?#[\]@!$&'()*+,;=%]*)?$/i;
        return urlPattern.test(value.trim());
    }

    function handleFormSubmit() {
        const affiliateUrl = 'http://shopify.pxf.io/rakNYv';
        try {
            window.parent.open(affiliateUrl, '_blank');
        } catch (e) {
            window.open(affiliateUrl, '_blank');
        }
        submit(inputValue);
    }

    return isMobile ?
        (
            <div className={'search-container'}>
                <div className="search-wrapper">
                    <Input placeholder="Paste Shopify store link..."
                           prefix={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                        fill="none">
                               <path fillRule="evenodd" clipRule="evenodd"
                                     d="M11.4941 11.4941C11.8195 11.1686 12.3472 11.1686 12.6726 11.4941L17.2559 16.0774C17.5814 16.4028 17.5814 16.9305 17.2559 17.2559C16.9305 17.5814 16.4028 17.5814 16.0774 17.2559L11.4941 12.6726C11.1686 12.3472 11.1686 11.8195 11.4941 11.4941Z"
                                     fill="#707BA0"/>
                               <path fillRule="evenodd" clipRule="evenodd"
                                     d="M8.33333 4.16667C6.03215 4.16667 4.16667 6.03215 4.16667 8.33333C4.16667 10.6345 6.03215 12.5 8.33333 12.5C10.6345 12.5 12.5 10.6345 12.5 8.33333C12.5 6.03215 10.6345 4.16667 8.33333 4.16667ZM2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333Z"
                                     fill="#707BA0"/>
                           </svg>}
                           onChange={handleChange}
                           value={inputValue}
                           disabled={loading}
                           className={cls("search-input", {error: error})}
                    />
                    {
                        error ? <p className="error-message">{error}</p> : null
                    }
                </div>
                <div className="options-wrapper">
                    {
                        searchOptions.map((option, index) => (
                            <div className="option"
                                 onClick={() => !loading && handleSelectOption(option)}
                                 key={index}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"
                                     fill="none">
                                    <path
                                        d="M4.83349 2.368L5.39728 1.80421C6.80289 0.398596 9.08184 0.398597 10.4875 1.80421C11.8931 3.20982 11.8931 5.48877 10.4875 6.89439L9.92243 7.45942M2.371 4.83049L1.80421 5.39728C0.398596 6.80289 0.398597 9.08184 1.80421 10.4875C3.20982 11.8931 5.48877 11.8931 6.89439 10.4875L7.45704 9.92481M4.6875 7.60417L7.60417 4.6875"
                                        stroke="#225AEA" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                                {option}
                            </div>
                        ))
                    }
                </div>
                <ButtonComponent onClick={handleFormSubmit}
                                 disabled={loading || disabled || error}
                                 className={cls("search-btn", {disabled: loading || disabled || error})}
                >
                    {
                        loading ?
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                 fill="none">
                                <path
                                    d="M10.0003 2.29175L10.0001 5.20841M10.0003 14.7917V17.7084M2.29175 10.0007H5.20841M14.7917 10.0007H17.7084M4.54965 4.54929L6.61186 6.61186M13.3885 13.3881L15.4509 15.4505M4.54988 15.4511L6.61227 13.3887M13.3887 6.61227L15.4511 4.54988"
                                    stroke="#707BA0" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            :
                            null
                    }
                    {
                        loading ? 'Detecting theme...' : 'Detect theme'
                    }
                </ButtonComponent>
            </div>
        )
        :
        (
            <div className={'search-container'}>
                <div className="search-wrapper">
                    <Input placeholder="Paste Shopify store link..."
                           prefix={<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                        fill="none">
                               <path fillRule="evenodd" clipRule="evenodd"
                                     d="M11.4941 11.4941C11.8195 11.1686 12.3472 11.1686 12.6726 11.4941L17.2559 16.0774C17.5814 16.4028 17.5814 16.9305 17.2559 17.2559C16.9305 17.5814 16.4028 17.5814 16.0774 17.2559L11.4941 12.6726C11.1686 12.3472 11.1686 11.8195 11.4941 11.4941Z"
                                     fill="#707BA0"/>
                               <path fillRule="evenodd" clipRule="evenodd"
                                     d="M8.33333 4.16667C6.03215 4.16667 4.16667 6.03215 4.16667 8.33333C4.16667 10.6345 6.03215 12.5 8.33333 12.5C10.6345 12.5 12.5 10.6345 12.5 8.33333C12.5 6.03215 10.6345 4.16667 8.33333 4.16667ZM2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333Z"
                                     fill="#707BA0"/>
                           </svg>}
                           onChange={handleChange}
                           value={inputValue}
                           disabled={loading}
                           className={cls("search-input", {error: error})}
                    />
                    <ButtonComponent onClick={handleFormSubmit}
                                     disabled={loading || disabled || error}
                                     className={cls("search-btn", {disabled: loading || disabled || error})}
                    >
                        {
                            loading ?
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                     fill="none">
                                    <path
                                        d="M10.0003 2.29175L10.0001 5.20841M10.0003 14.7917V17.7084M2.29175 10.0007H5.20841M14.7917 10.0007H17.7084M4.54965 4.54929L6.61186 6.61186M13.3885 13.3881L15.4509 15.4505M4.54988 15.4511L6.61227 13.3887M13.3887 6.61227L15.4511 4.54988"
                                        stroke="#707BA0" strokeWidth="1.5" strokeLinecap="round"
                                        strokeLinejoin="round"/>
                                </svg>
                                :
                                null
                        }
                        {
                            loading ? 'Detecting theme...' : 'Detect theme'
                        }
                    </ButtonComponent>
                </div>
                {
                    error ? <p className="error-message">{error}</p> : null
                }
                <div className="options-wrapper">
                    {
                        searchOptions.map((option, index) => (
                            <div className="option"
                                 onClick={() => !loading && handleSelectOption(option)}
                                 key={index}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"
                                     fill="none">
                                    <path
                                        d="M4.83349 2.368L5.39728 1.80421C6.80289 0.398596 9.08184 0.398597 10.4875 1.80421C11.8931 3.20982 11.8931 5.48877 10.4875 6.89439L9.92243 7.45942M2.371 4.83049L1.80421 5.39728C0.398596 6.80289 0.398597 9.08184 1.80421 10.4875C3.20982 11.8931 5.48877 11.8931 6.89439 10.4875L7.45704 9.92481M4.6875 7.60417L7.60417 4.6875"
                                        stroke="#225AEA" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                                {option}
                            </div>
                        ))
                    }
                </div>
            </div>
        )
};

export default Index;